export default __webpack_public_path__ + "static/media/up_ok.5e203088.svg";